/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { DppBadgesTab } from '@/app/(client)/my-styles/-components/DppBadgesTab';
import {
  type EntityKindPath,
  isEntityKindPath,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(detail)/$kind/$id/badges',
)({
  component: DppBadgesRoute,
});

function DppBadgesRoute() {
  const { kind, id } = Route.useParams() as {
    kind: EntityKindPath;
    id: string;
  };
  const { data: entity } = useEntityDetail(kind, id);
  if (!isEntityKindPath(kind)) return null;
  return (
    <DppBadgesTab
      kind={kind}
      entityId={id}
      isStoryActive={Boolean(entity?.isStoryActive)}
    />
  );
}
